import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Route, RouteProgress, RouteService } from '../../services/route';

@Component({
  selector: 'route',
  imports: [RouterLink],
  templateUrl: './route.html',
  styleUrl: './route.css',
})
export class RouteComponent implements OnInit{
  progress: RouteProgress;
  route: Route;
  constructor(private routeService: RouteService){
    
  }

  async ngOnInit(): Promise<void> {
    this.progress = new RouteProgress();
    this.route = new Route();
    return;
    this.route = await this.routeService.findById('');
    this.progress = this.routeService.calcRouteProgress(this.route);
  }

}
